import React, { useContext, useEffect } from "react";
import ManageCoachPrograms from "./ManageCoachPrograms";
import StudentPrograms from "./ManageStudentPrograms";
import { RoleType, UserContext } from "app/contexts/UserContext";
import useCalendarPreferences from "app/utils/hooks/useCalendarPreferences";

const ManagePrograms = () => {
  const user = useContext(UserContext);
  const { refresh } = useCalendarPreferences();

  useEffect(() => {
    refresh();
  }, [refresh]);

  const canCreate = user.role === RoleType.COACH || user.role === RoleType.ADMIN;
  return canCreate ? <ManageCoachPrograms /> : <StudentPrograms />;
};

export default ManagePrograms;
